import { useGlobalData } from "../data/GeneralData";
import React, { useState, useEffect, useCallback } from "react";
import NavItem from "./NavItem";
import { Link } from "react-router-dom";

export default function Header() {
  const { date, year, location } = useGlobalData();
  // const { date, year, location } = useGlobalData();
  const [navOpen, setNavOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const toggleNav = () => {
    setNavOpen(!navOpen);
    document.body.classList.toggle("scroll-lock", !navOpen);
  };

  const closeNav = () => {
    setNavOpen(false);
    document.body.classList.remove("scroll-lock");
  };

  const handleScroll = useCallback(() => {
    if (window.scrollY > lastScrollY) {
      setShowHeader(false);
      document.body.classList.add("header-shrink");
    } else {
      setShowHeader(true);
      document.body.classList.remove("header-shrink");
    }
    setLastScrollY(window.scrollY);
  }, [lastScrollY]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  return (
    <>
      <div id="modal-container"></div>
      <div id="modal-video-container"></div>
      <header id="header">
        <div className="top-bar">
          <div className="container">
            <div className="row">
              <div className="col-12 d-none d-lg-block text-end">
                <a
                  target="_blank"
                  href="https://balancedcomp.com"
                  rel="noopener noreferrer"
                >
                  About BalancedComp
                </a>
                <span className="spacer">•</span>
                <span>
                  {date}, {year}
                </span>
                <span className="spacer">•</span>
                <span>{location}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className="mobile-menu d-block d-lg-none">
          <div className="row align-items-center">
            <div className="col-4">
              <Link className="mobile-logo" to="/" onClick={closeNav}>
                <img
                  className="img-fluid"
                  src="../img/logo-fincomp.webp"
                  alt="FinComp 2025 by BalancedComp"
                />
              </Link>
            </div>
          </div>
          <div
            className={`toggle-nav ${navOpen ? "toggle-active" : ""}`}
            onClick={toggleNav}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        {/* Navigation */}
        <div className={`navigation ${navOpen ? "nav-open" : ""} pt-3`}>
          <div className="container position-relative">
            <div className="row align-items-center">
              <div className="col">
                <div className="row align-items-center">
                  <div className="col col-lg-3">
                    <Link className="logo" to="/" onClick={closeNav}>
                      <img
                        className="img-fluid"
                        src="../img/logo-fincomp.webp"
                        alt="FinComp by BalancedComp"
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg text-center text-lg-end flex-lg-grow-1">
                <div className="d-flex d-lg-none justify-content-center">
                  <div className="date-location">{date}, 2025</div>
                </div>
                <ul id="menu-global" className="menu">
                  <NavItem to="/Speakers" closeNav={closeNav}>
                    Speakers
                  </NavItem>

                  {/* <NavItem to="/Speakers" closeNav={closeNav}>
                    Speakers
                    <NavItem
                      to="/Speakers"
                      closeNav={closeNav}
                      className="d-none d-lg-block"
                    >
                      2025 Speakers
                    </NavItem>
                    <NavItem to="/Speakers/2024" closeNav={closeNav}>
                      2024 Speakers
                    </NavItem>
                    <NavItem to="/Speakers/2023" closeNav={closeNav}>
                      2023 Speakers
                    </NavItem>
                  </NavItem> */}
                  <NavItem to="/Agenda" closeNav={closeNav}>
                    Agenda
                  </NavItem>
                  <NavItem to="/Hotel" closeNav={closeNav}>
                    Hotel
                  </NavItem>
                  <NavItem to="/Visit" closeNav={closeNav}>
                    Things To Do
                  </NavItem>
                  {/* <NavItem to="/Sponsors" closeNav={closeNav}>
                    Sponsors
                  </NavItem> */}
                  {/* <NavItem to="/FAQ" closeNav={closeNav}>
                    FAQ
                  </NavItem> */}

                  <NavItem to="/Sponsors" closeNav={closeNav}>
                    Sponsors
                  </NavItem>
                  <NavItem
                    button
                    to="/Registration"
                    closeNav={closeNav}
                    className="ms-3"
                  >
                    Register
                  </NavItem>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
